/** @jsx jsx */
import { Box, Heading, Flex, jsx } from "theme-ui"
import { IGatsbyImageData } from "gatsby-plugin-image"

import ImageWithDropshadow from "components/common/ImageWithDropshadow"

interface TimelineBlockProps {
  //enables sx prop to be passed down from parent
  className?: string
  content: string
  image?: IGatsbyImageData
  imageAlt?: string
}

const TimelineBlock = ({
  className,
  image,
  content,
  imageAlt = "needs image alt",
}: TimelineBlockProps) => {
  return (
    // <motion.div
    //   ref={ref}
    //   animate={controls}
    //   initial="hidden"
    //   variants={timelineBlockVariants}
    //   className="timelineBlock"
    // >
    <Box
      as="article"
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        position: "relative",
        mb: [18, null, null, 48],
        "& .timelineBlock": {
          flex: ["0 1 80%", null, null, "1 50%"],
          maxWidth: ["100%", null, null, "400px"],
          order: 0,
        },
        "& .ag-timeline-card_point-box.active .ag-timeline-card_point": {
          backgroundColor: "secondary",
        },
      }}
      className="js-timeline_item js-ag-animated ag-timeline_item"
    >
      <Flex
        className="timelineBlock"
        sx={{
          flexDirection: "column",
        }}
      >
        <Heading as="h2" variant="bodyTitle" sx={{ mb: image ? 8 : 0 }}>
          {content}
        </Heading>
        {image && (
          <ImageWithDropshadow
            image={image}
            imageAlt={imageAlt}
            sx={{
              maxWidth: "365px",
              width: ["100%", null, null, "365px"],
              height: ["240px", null, null, "308px"],
            }}
          />
        )}
      </Flex>
    </Box>
    // </motion.div>
  )
}

export default TimelineBlock
